import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["className", "fillColor", "fillMainColor", "fillGray", "fillLightGray", "fillCautionColor", "fillTransparentGray", "borderBlue", "borderGray", "borderLight", "borderCaution", "fontFixed", "fontBold", "large", "medium", "small", "largeFont", "favBtn", "favBtnWithLabel", "listRow", "scale", "inline", "transparent", "loading", "hoverAnimation", "bgColor", "withIcon", "disabledWithGray"];
import buttonStyles from "@/styles/Button.module.scss";
import React, { forwardRef } from "react";
import classnames from "classnames";
import { jsx as _jsx } from "react/jsx-runtime";
const Button = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      className,
      fillColor,
      fillMainColor,
      fillGray,
      fillLightGray,
      fillCautionColor,
      fillTransparentGray,
      borderBlue,
      borderGray,
      borderLight,
      borderCaution,
      fontFixed,
      fontBold,
      large,
      medium,
      small,
      largeFont,
      favBtn,
      favBtnWithLabel,
      listRow,
      scale,
      inline,
      transparent,
      loading,
      hoverAnimation,
      bgColor,
      withIcon,
      disabledWithGray
    } = props,
    restProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsx("button", {
    ref: ref,
    className: classnames(buttonStyles.btn, className, {
      [buttonStyles.fillCautionColor]: fillCautionColor,
      [buttonStyles.borderGray]: borderGray,
      [buttonStyles.fontFixed]: fontFixed
    }),
    children: props.children
  });
});
Button.displayName = "Button";
export default Button;